import React, { useState } from "react";
import { Link } from "react-router-dom";
import API from "../services/api";
import "./AddSurplus.css";

function AddSurplus() {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    quantity: "",
    location: "",
    availableUntil: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const hotelId = localStorage.getItem("hotelId");

    if (!hotelId) {
      alert("Hotel ID missing. Please login again.");
      return;
    }

    const payload = {
      hotelId: hotelId,
      ...formData
    };

    try {
      const res = await API.post("/surplus/add", payload);

      alert("Surplus Submitted Successfully!");
      console.log(res.data);

      setFormData({
        title: "",
        description: "",
        quantity: "",
        location: "",
        availableUntil: ""
      });

    } catch (error) {
      console.error(error);
      alert("Error adding surplus!");
    }
  };

  return (
    <>
      {/* SAME NAVBAR AS DASHBOARD */}
      <header className="header">
        <div className="header-container">
          <div className="logo">
            <h1>SaveBite</h1>
          </div>

          <nav className="navigation">
            <Link to="/hotel/dashboard" className="nav-link">Dashboard</Link>
            <Link to="/hotel/donationevent" className="nav-link">Donation</Link>

           <Link to="/hotel/account" className="nav-link">My Account</Link>

          </nav>
        </div>
      </header>

     {/* PAGE CONTENT */}
<div className="surplus-page">
  <div className="surplus-card">
    <h1 className="surplus-title">Add Surplus Food</h1>
    <p className="surplus-subtitle">
      Share excess food to reduce waste and help NGOs 🌱
    </p>

    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label>Title</label>
        <input
          type="text"
          name="title"
          placeholder="e.g., Fresh Rice, Veg Meal"
          value={formData.title}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label>Description</label>
        <textarea
          name="description"
          placeholder="Describe the food, condition, type..."
          value={formData.description}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Quantity</label>
        <input
          type="text"
          name="quantity"
          placeholder="e.g., 20 plates, 5 kg"
          value={formData.quantity}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Location</label>
        <input
          type="text"
          name="location"
          placeholder="Hotel address or pickup point"
          value={formData.location}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Available Until</label>
        <input
          type="datetime-local"
          name="availableUntil"
          value={formData.availableUntil || ""}
          onChange={handleChange}
          required
        />
      </div>

      <button type="submit" className="submit-btn">
        Submit Surplus
      </button>
    </form>
  </div>
</div>

    </>
  );
}

export default AddSurplus;
